import styles from "./card-heading.module.css"
export const CardHeading = ({ trigger, product }) => {


    return (
        <div className={styles.card_heading_holder}>
            <div className={styles.card_heading_container}>
                <p className={styles.characteristic_name}>Тип модели</p>
                <p className={styles.characteristic_value}>{product?.model_type}</p>
            </div>
            <div className={styles.card_heading_container}>
                <p className={styles.characteristic_name}>Код двигателя</p>
                <p className={styles.characteristic_value}>{product?.engine_code}</p>
            </div>
            <div className={styles.card_heading_container}>
                <p className={styles.characteristic_name}>Мощность кВт(л.с.)</p>
                <p className={styles.characteristic_value}>{product?.power_kw}</p>
            </div>
            <div className={styles.card_heading_container}>
                <p className={styles.characteristic_name}>Объем двигателя</p>
                <p className={styles.characteristic_value}>{product?.volume}</p>
            </div>
            <div className={styles.card_heading_container}>
                <p className={styles.characteristic_name}>Год выпуска</p>
                <p className={styles.characteristic_value}>{product?.manufacture_year}</p>
            </div>
            <div className={styles.card_heading_trigger}>{trigger}</div>
        </div>
    );
};